// tslint:disable: max-line-length triple-equals
import Icon from 'lqa-ui/lib/Components/Icon';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { clear, getItem, removeItem, setItem } from '../../utils/localStorage';
import Avatar from 'lqa-ui/lib/Components/Avatar';
import { useNavigate } from 'react-router-dom';
import {
  deleteProfilePic,
  getProfilePic,
  updateProfilePic,
  getAchivmentEntity,
  getAchivmentMonthly,
} from '../../requests/profilepic';
import { ClearAllIndexedDB, CreateDataByIndexedDB } from '../../indexed/index';
import Resizer from 'react-image-file-resizer';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../helpers/showMessage';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import SettingsCard from './SettingsCard';
import { getProfileCVs } from '../StartCV/apiCaller';
import ControlInput from 'lqa-ui/lib/Components/ControlInput';
import profile from '../../../www/assets/gif/profile.gif';
import { updateProfile } from '../../components/MyLQAProfile/apicaller';
import { authMeRes } from '../../requests/notifications';
import AchivementCard from './AchivementCard';
import MemberCard from './MemberCard';
import { convertToTitleCaseAndCapitalizeFirst } from '../../utils/common';
import { logOutUser } from '../../requests/login';
import { EMAIL_REGEX } from '../../utils/regex';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { sentryReport } from '../../helpers/sentry';
import { useTranslation } from 'react-i18next';
import { ButtonLarge } from '../../app/common/sharedComponents/buttons/ButtonLarge';
import { NotificationPreferences } from '../../app/common/sharedComponents/NotificationPreferences';
import { ButtonContainer, ImageInputContainer } from './PilotWelcome.styled';
import { Modal } from './../../app/common/sharedComponents/Modal';
import { Headline3 } from './../../app/common/typography';
import { ButtonBlockColumn } from './../../app/common/sharedStyledComponents/GenericStyles.styled';
import { Cropper } from './../../app/common/sharedComponents/Cropper';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  color: #fff;
  background-color: #fff;
  width: 100%;
  padding-bottom: 100px;
`;

const Header = styled('div')`
  background: #08142f;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  display: flex;
  align-items: center;
  color: #ffffff;
  height: 40px;
  padding: 0 1rem 0 1rem;
`;

const ProfileContainer = styled('div')`
  display: flex;
  width: 95%;
  margin-right: 1rem;
  justify-content: space-between;
`;

const Circle = styled('img')`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
`;

const LoadingCircle = styled('div')`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
`;

const EditCircle = styled('label')`
  position: absolute;
  width: 30px;
  height: 30px;
  left: 130px;
  top: 225px;
  background: #4fada6;
  border: 0.925241px solid #ffffff;
  border-radius: 50%;
  text-align: center;
  justify-content: center;
  cursor: pointer;
`;

const Name = styled('h3')`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  text-align: right;
  color: #031c38;
  margin-bottom: 0;
  text-transform: capitalize;
`;

const Position = styled('h3')`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  /* or 133% */

  text-align: right;

  color: #717171;
`;

const Website = styled('h3')`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  align-items: center;
  text-align: right;
  color: #4fada6;
`;

const ContentConatiner = styled('div')`
  box-sizing: border-box;
  width: 95%;
  height: auto;
  border: 1px solid #071c3e;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: left;
  row-gap: 1rem;
  margin: 1rem 3rem 1rem 3rem;
  padding: 0.5rem 0.5rem 1rem 0.5rem;
`;

const CardContentContainer = styled('div')`
  box-sizing: border-box;
  width: 95%;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: left;
  row-gap: 1rem;
  padding: 0.5rem 0.5rem 1rem 0.5rem;

  h3 {
    margin-bottom: 0px;
  }
`;

const Image = styled('div')`
  width: 100%;
  height: 217px;
  background: url('/assets/img/image.png');
  // background: #58C3BB;
  border-radius: 16px;
  background-repeat: no-repeat;
  background-size: 100%;
`;

const Heading = styled('h3')`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  color: #071c3e;
`;

const TextIconContainer2 = styled.div`
  display: flex;
  height: 30px;
`;

const TextContainer = styled.span`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #1f1f1f;
  margin-left: 10px;
  width: 283px;
  height: 30px;
`;

const ImageBackgroundContainer = styled('div')`
  background: #d9d9d9;
  border-radius: 10px;
  text-align: center;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: 20px 18px;
  margin: 0 15px;
`;

const BenefitsContainer = styled('div')`
  display: flex;
  margin: 0 15px 20px 15px;
  flex-direction: column;
  gap: 12px;
  & .benefits-container {
    gap: 10px;
    & svg {
      fill: #4fada6;
    }
  }
`;

const HeadingProfile = styled('div')`
  font-family: Source Sans Pro;
  font-size: 13px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0px;
  text-align: center;
  color: #717171;
  position: relative;
  left: 0;
  margin-bottom: 38px;
  padding: 0px 6px 0 3px;
  width: 100%;
`;

const ButtonRegisterContainer = styled.div`
  margin-top: 10px;
  width: 100%;
`;

const ButtonStartCVContainer = styled.div`
  margin: 10px;
`;

const TitleOptionProfile = styled.div`
  margin-bottom: 12px;
  text-align: center;
`;

const Benefits = [
  'Memberships are always free',
  'Achieve scores, levels, and points based off your activities',
  'Achievements stay with you throughout your career with LQA',
];
export interface Achievement {
  activityType: string;
  sum: string;
  count: string;
  entity: string | null;
  entityId: string | null;
  isProgress: boolean | undefined | null;
}
const PilotWelcome = () => {
  const regex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^~])[A-Za-z\d@$!%*?&#^~]{0,}$/;
  const navigate = useNavigate();
  const userData = getItem('user');
  const userProfile = getItem('userProfile');
  const user = getItem('user');
  const { t } = useTranslation();
  const userInfo = userProfile || user.user;
  const selectedHotel = getItem('selectedHotel');
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef<any>('');
  const [isLoading, setIfLoading] = useState(false);
  const [existingCVInformation, setExistingCVInformation] = useState([]);
  const [isCvAPICallCompleted, setIsCvAPICallCompleted] = useState(false);
  // Set image here
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [image, setImage] = useState<any>(null);
  const [membershipCode, setMembershipCode] = useState(
    userProfile &&
      userProfile.membershipCode &&
      userProfile.membershipCode != null &&
      userProfile.membershipCode !== 'NULL'
      ? userProfile.membershipCode
      : undefined
  );
  const [personalEmail, setPersonalEmail] = useState(
    userProfile &&
      userProfile.userEmail &&
      userProfile.userEmail != null &&
      userProfile.userEmail !== 'NULL'
      ? userProfile.userEmail
      : undefined
  );
  const [form, setForm] = useState({
    email: '',
    userPassword: '',
    confirmUserPassword: '',
  });

  const [insertDate, setInsertDate] = useState(
    userProfile && userProfile.insertDate && userProfile.insertDate != null
      ? userProfile.insertDate
      : undefined
  );
  const [achivmentData, setAchivmentData] = useState<Achievement[]>([]);
  const [isLogoutLoading, setIsLogoutLoading] = useState(false);
  const [profileTier, setProfileTier] = useState(
    userProfile &&
      userProfile.profileTier &&
      userProfile.profileTier != null &&
      userProfile.profileTier !== 'NULL'
      ? userProfile.profileTier
      : undefined
  );

  useEffect(() => {
    (() => {
      getProfilePic().then((res) => {
        if (res && res[0] && res[0].url) {
          setImage(res[0].url);
        }
      });
    })();
  }, []);

  const resizeFile = (file: File) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        300,
        300,
        'JPEG',
        50,
        0,
        (uri) => {
          resolve(uri);
        },
        'file'
      );
    });

  const uploadImageHandler = async (croppedImage: File | null) => {
    if (croppedImage) {
      setIfLoading(true);
      const resizedImage: any = await resizeFile(croppedImage);
      const formData = new FormData();
      formData.append('file', resizedImage);
      updateProfilePic(formData).then(() => {
        getProfilePic()
          .then((res) => {
            if (res && res[0] && res[0].url) {
              setItem('pic', res[0].url);
              setIfLoading(false);
              showSuccessMessage('Profile Pic Updated Successfully');
              setImage(res[0].url);
              setIsOpen(false);
            }
          })
          .catch(() => {
            setIfLoading(false);
            showErrorMessage('Something went wrong');
          });
      });
    }
  };

  const deleteImageHandler = async (event) => {
    await getProfilePic().then(async (res) => {
      const id = res[0].id;
      await deleteProfilePic(id)
        .then(async (res) => {
          CreateDataByIndexedDB(`userProfilePic`, undefined, selectedHotel);
          showSuccessMessage('Profile Pic Deleted Successfully');
          removeItem('pic');
          localStorage.setItem('userProfilePicture', '');
          setIfLoading(false);
          window.location.reload();
        })
        .catch(() => {
          setIfLoading(false);
          showErrorMessage('Something went wrong');
        });
    });
  };

  const signOutClickHandler = () => {
    setIsLogoutLoading(true);
    ClearAllIndexedDB();
    const userData = getItem('user');
    const accessToken = userData.accessToken;
    logOutUser(accessToken)
      .then((res) => {
        window.location.href = '/login';
        try {
          const userProfile = getItem('userProfile');
          const isUserIgnoredPin = getItem('isUserIgnoredPin')
            ? getItem('isUserIgnoredPin')
            : undefined;
          const selectedHotelId = getItem('selectedHotel');
          const selectedClientId = getItem('selectedClient');
          clear();
          setItem('isUserIgnoredPin', isUserIgnoredPin);
          let userEmail: string;
          if (userData && userData.user && userData.user.userEmail) {
            userEmail = userData.user.userEmail.trim().toLowerCase();
          } else {
            userEmail =
              userProfile && userProfile.userEmail.trim().toLowerCase();
          }
          if (userData && userData.user && userData.user.isPinSet) {
            localStorage.setItem('isPinSet', userData.user.isPinSet);
          } else if (userProfile && userProfile.isPinSet) {
            localStorage.setItem('isPinSet', userProfile.isPinSet);
          }
          if (userEmail) {
            localStorage.setItem('email', userEmail);
          }
          if (userData && userData.user && userData.user.userPhone) {
            localStorage.setItem('phonenumber', userData.user.userPhone);
          }
          localStorage.setItem('selectedHotel', selectedHotelId);
          localStorage.setItem('selectedClient', selectedClientId);
        } catch (err) {
          console.error('err', err);
        }
      })
      .catch((err) => {
        setIsLogoutLoading(false);
        sentryReport(err.response.data, err.message, err.code, {
          summaryError: t(
            'COMMON.ERROR_BOUNDARIES.SOMETHING_WENT_WRONG_WHILE_ENDING_SESSION'
          ),
          path: '/pilotwelcome',
        });
      });
  };

  const updatePersonalEmailHandler = () => {
    // validate email, password, confirm password
    if (
      form.email === '' ||
      !EMAIL_REGEX.test(form.email) ||
      form.userPassword === '' ||
      form.confirmUserPassword === '' ||
      form.userPassword.length < 7 ||
      !regex.test(form.userPassword) ||
      !(form.userPassword === form.confirmUserPassword)
    ) {
      showErrorMessage('Please fill all data');
      return;
    }
    if (
      userData &&
      userData.user &&
      userData.user.userEmail &&
      userData.user.userEmail.toLowerCase() === form.email.toLowerCase()
    ) {
      showErrorMessage('Use personal email instead of hotel email');
      return;
    }
    const payLoad = {
      password: form.userPassword,
      userEmail: form.email.toLowerCase().trim(),
    };
    if (!personalEmail) {
      updateProfile(payLoad, userData.accessToken)
        .then(() => {
          authMeRes().then((res: any) => {
            if (res && res.data) {
              setItem('user', JSON.stringify(res.data));
            }
            if (res && res.data && res.data.userProfile) {
              setItem('userProfile', JSON.stringify(res.data.userProfile));
              setTimeout(() => {
                window.location.reload();
              }, 2000);
            }
          });
        })
        .catch((error) => {
          const errorResponse = error.response && error.response.data;
          if (
            errorResponse &&
            errorResponse.message &&
            Array.isArray(errorResponse.message) &&
            errorResponse.message[0].constraints &&
            errorResponse.message[0].constraints.email
          ) {
            const errorMessage = errorResponse.message[0].constraints.email;
            sentryReport(error.response.data, error.message, error.code, {
              alertMessage: errorMessage,
              method: 'updatePersonalEmailHandler',
            });
            showErrorMessage(errorMessage);
          } else {
            sentryReport(error.response.data, error.message, error.code, {
              alertMessage: t('COMMON.ERROR_BOUNDARIES.SOMETHING_WENT_WRONG'),
              method: 'updatePersonalEmailHandler',
            });
            showErrorMessage(t('COMMON.ERROR_BOUNDARIES.SOMETHING_WENT_WRONG'));
          }
        });
    }
  };

  const refreshExistingCVs = async () => {
    setIsCvAPICallCompleted(false);
    const data = await getProfileCVs();

    setExistingCVInformation(data);
    setIsCvAPICallCompleted(true);
  };

  useEffect(() => {
    if (membershipCode) {
      refreshExistingCVs();
      Promise.all([getAchivmentMonthly(), getAchivmentEntity()]).then(
        (res: Achievement[][]) => {
          res[0].forEach((item: any) => {
            item.isShowProgress = true;
          });
          const data = res[1].concat(res[0]);
          setAchivmentData(data);
        }
      );
    }
  }, [membershipCode]);

  return (
    <>
      <Container>
        <div className="pilot-header background-08142f w-100">
          <AppHeader navigateTo="/dashboard" />
          <Header>Profile</Header>
        </div>
        <CardContentContainer>
          <ProfileContainer className="w-100">
            {isLoading ? (
              <LoadingCircle>
                <LoadingContent layout="flex" />
              </LoadingCircle>
            ) : image ? (
              <Circle src={image} />
            ) : (
              <Avatar
                name={`${userInfo.userFirstName.split(' ').join('')} ${userInfo.userLastName.split(' ').join('')}`}
                size={150}
                style={{ background: '#4fada6' }}
              />
            )}
            {membershipCode && personalEmail && (
              <EditCircle
                onClick={() => {
                  setIsOpen(true);
                }}
              >
                <Icon kind="edit" height={17} width={17} className="mt-5" />
              </EditCircle>
            )}
            <div className="mt-20 d-flex flex-direction-column space-between">
              <div>
                <Name>
                  {userInfo.userFirstName} {userInfo.userLastName}
                </Name>
                <Position>
                  {' '}
                  {convertToTitleCaseAndCapitalizeFirst(
                    userData && userData.user && userData.user.jobTitle
                  )}
                </Position>
                {membershipCode && personalEmail && (
                  <Website>
                    {userData &&
                    userData.user &&
                    userData.user.brands &&
                    userData.user.brands.length
                      ? userData.user.brands[0].hotels[0].name
                      : ''}
                  </Website>
                )}
              </div>
              {existingCVInformation.length > 0 && (
                <div className="text-right pb-5">
                  <span
                    onClick={() => navigate('/profile/cv')}
                    className="f-15 text-underline color-717171"
                  >
                    Employment History
                  </span>
                </div>
              )}
            </div>
          </ProfileContainer>
        </CardContentContainer>
        {membershipCode && personalEmail && profileTier && (
          <CardContentContainer>
            <MemberCard
              memberShipType={profileTier}
              membershipCode={membershipCode}
              insertDate={insertDate}
            />
          </CardContentContainer>
        )}

        {(!membershipCode || !personalEmail) && (
          <>
            <h3
              className="fw-600 f-24 lh-24 sans-font font-normal color-071C3E "
              style={{
                padding: '0 1rem 0 1rem',
                marginTop: '25px',
                marginRight: 'auto',
              }}
            >
              Sign up for{' '}
              <span
                style={{
                  fontStyle: 'italic',
                }}
              >
                my
              </span>
              LQA Membership
            </h3>
            <ImageBackgroundContainer>
              <HeadingProfile>
                <div className="line1" style={{ display: 'inline' }}>
                  Your membership is yours. For your{' '}
                  <span
                    style={{
                      fontStyle: 'italic',
                    }}
                  >
                    my
                  </span>
                  LQA profile, we suggest using your personal email address.{' '}
                </div>
              </HeadingProfile>
              <img src={profile} className="w-100 mb-20" />
              <ControlInput
                label="Email Address"
                name="username"
                value={form.email}
                required={true}
                style={{
                  textAlign: 'left',
                }}
                onChange={(e) => {
                  setForm({ ...form, email: e.target.value });
                }}
                type="email"
              />
              <div className="text-left mt-20 d-flex flex-direction-column gap-15 w-100">
                <div>
                  <span className="fw-400 f-15 lh-20 color-717171 mb-10">
                    Create Your password
                  </span>
                  <ControlInput label="hidden" value={''} className="hide" />
                  <ControlInput
                    label="Password"
                    name="password"
                    value={form.userPassword}
                    onChange={(e) => {
                      setForm({ ...form, userPassword: e.target.value });
                    }}
                    required={true}
                    hasError={false}
                    disabled={false}
                    secureTextEntry={true}
                    revealPasswordAddOn={true}
                  />
                </div>
                <div className="mb-10">
                  <span className="fw-400 f-15 lh-20 color-717171 mb-10">
                    Confirm password
                  </span>
                  <ControlInput label="hidden" value={''} className="hide" />
                  <ControlInput
                    label="Password"
                    name="password"
                    value={form.confirmUserPassword}
                    onChange={(e) => {
                      setForm({ ...form, confirmUserPassword: e.target.value });
                    }}
                    required={true}
                    hasError={false}
                    disabled={false}
                    secureTextEntry={true}
                    revealPasswordAddOn={true}
                  />
                </div>
                <div>
                  <Icon
                    kind={
                      form.userPassword.length > 7 ? 'status-success' : 'clear'
                    }
                    width={13}
                    height={13}
                  />
                  <span className="fw-400 f-15 lh-20 color-979797">
                    {' '}
                    Password should be at least 8 Character long{' '}
                  </span>
                  <br />
                  <Icon
                    kind={
                      regex.test(form.userPassword) ? 'status-success' : 'clear'
                    }
                    width={13}
                    height={13}
                  />
                  <span className="fw-400 f-15 lh-20 color-979797">
                    {' '}
                    Uppercase, Letters, Numbers and Special Characters{' '}
                  </span>
                  <br />
                  <Icon
                    kind={
                      form.userPassword &&
                      form.userPassword === form.confirmUserPassword
                        ? 'status-success'
                        : 'clear'
                    }
                    width={13}
                    height={13}
                  />
                  <span className="fw-400 f-15 lh-20 color-979797">
                    {' '}
                    Password Must Match{' '}
                  </span>
                </div>
              </div>
              <ButtonRegisterContainer>
                <ButtonLarge
                  title="Register Now"
                  onClick={() => {
                    updatePersonalEmailHandler();
                  }}
                  backgroundColor="oxfordBlue"
                />
              </ButtonRegisterContainer>
            </ImageBackgroundContainer>
            {!(!personalEmail && membershipCode) && (
              <div className="mb-20 mt-20">
                <div
                  className="text-center f-17 fw-600 mb-20"
                  style={{ color: 'black', marginTop: '35px' }}
                >
                  Incredible Benefits Of Creating A Profile
                </div>
                <BenefitsContainer>
                  {Benefits.map((data, index) => {
                    return (
                      <div
                        className="d-flex mt-10 benefits-container"
                        key={index}
                      >
                        <div>
                          <Icon
                            kind="tick-points"
                            width={20}
                            height={20}
                            key={index}
                          />
                        </div>
                        <div>{data}</div>
                      </div>
                    );
                  })}
                  <div className="d-flex mt-10 benefits-container">
                    <div>
                      <Icon kind="tick-points" width={20} height={20} />
                    </div>
                    <div>
                      <span className="font-italic">my</span>LQA helps you grow
                      your career in the luxury service industry
                    </div>
                  </div>
                </BenefitsContainer>
              </div>
            )}
          </>
        )}
        {membershipCode &&
          personalEmail &&
          isCvAPICallCompleted &&
          !existingCVInformation.length && (
            <>
              <ContentConatiner>
                <Image />
                <Heading> Complete Your Profile </Heading>
                <TextIconContainer2>
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_4_4858)">
                      <path
                        d="M4.85742 9.71456L7.34671 11.706C7.41356 11.761 7.49184 11.8005 7.57586 11.8215C7.65988 11.8425 7.74753 11.8445 7.83242 11.8274C7.91813 11.8113 7.99937 11.777 8.07061 11.7267C8.14185 11.6764 8.20143 11.6114 8.24528 11.536L12.1431 4.85742"
                        stroke="#4FADA6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.50028 16.3931C12.8594 16.3931 16.3931 12.8594 16.3931 8.50028C16.3931 4.14117 12.8594 0.607422 8.50028 0.607422C4.14117 0.607422 0.607422 4.14117 0.607422 8.50028C0.607422 12.8594 4.14117 16.3931 8.50028 16.3931Z"
                        stroke="#4FADA6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4_4858">
                        <rect width="17" height="17" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <TextContainer> Add Professional LQA CV</TextContainer>
                </TextIconContainer2>
                <TextIconContainer2>
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_4_4858)">
                      <path
                        d="M4.85742 9.71456L7.34671 11.706C7.41356 11.761 7.49184 11.8005 7.57586 11.8215C7.65988 11.8425 7.74753 11.8445 7.83242 11.8274C7.91813 11.8113 7.99937 11.777 8.07061 11.7267C8.14185 11.6764 8.20143 11.6114 8.24528 11.536L12.1431 4.85742"
                        stroke="#4FADA6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.50028 16.3931C12.8594 16.3931 16.3931 12.8594 16.3931 8.50028C16.3931 4.14117 12.8594 0.607422 8.50028 0.607422C4.14117 0.607422 0.607422 4.14117 0.607422 8.50028C0.607422 12.8594 4.14117 16.3931 8.50028 16.3931Z"
                        stroke="#4FADA6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4_4858">
                        <rect width="17" height="17" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <TextContainer>
                    Start engaging with your LQA community
                  </TextContainer>
                </TextIconContainer2>
                <TextIconContainer2>
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_4_4858)">
                      <path
                        d="M4.85742 9.71456L7.34671 11.706C7.41356 11.761 7.49184 11.8005 7.57586 11.8215C7.65988 11.8425 7.74753 11.8445 7.83242 11.8274C7.91813 11.8113 7.99937 11.777 8.07061 11.7267C8.14185 11.6764 8.20143 11.6114 8.24528 11.536L12.1431 4.85742"
                        stroke="#4FADA6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.50028 16.3931C12.8594 16.3931 16.3931 12.8594 16.3931 8.50028C16.3931 4.14117 12.8594 0.607422 8.50028 0.607422C4.14117 0.607422 0.607422 4.14117 0.607422 8.50028C0.607422 12.8594 4.14117 16.3931 8.50028 16.3931Z"
                        stroke="#4FADA6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4_4858">
                        <rect width="17" height="17" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <TextContainer>
                    {' '}
                    Start Achievements through daily interactions
                  </TextContainer>
                </TextIconContainer2>
                <ButtonStartCVContainer>
                  <ButtonLarge
                    title="Start CV"
                    onClick={() =>
                      navigate('/start-cv', {
                        state: { isPreviousHotelExperience: !getItem('selectedHotel') },
                      })
                    }
                    backgroundColor="oxfordBlue"
                  />
                </ButtonStartCVContainer>
              </ContentConatiner>
            </>
          )}
        {membershipCode && personalEmail && (
          <AchivementCard data={achivmentData} />
        )}
        <div className="setting-wrapper">
          <SettingsCard />
          <NotificationPreferences />
        </div>
        <ButtonContainer>
          <ButtonLarge
            outlined={true}
            inverted={true}
            title={t('COMMON.PROFILE.LOGOUT')}
            backgroundColor="oxfordBlue"
            loading={isLogoutLoading}
            onClick={signOutClickHandler}
          />
        </ButtonContainer>
      </Container>
      {isOpen && (
        <Modal isOpen={isOpen}>
          <TitleOptionProfile>
            <Headline3>Choose an Option for Profile Photo</Headline3>
          </TitleOptionProfile>
          <ButtonBlockColumn>
            <ButtonLarge
              title="Edit"
              loading={isLoading}
              disabled={isLoading}
              backgroundColor="oxfordBlue"
              onClick={() => inputRef.current && inputRef.current.click()}
            />
            <ImageInputContainer
              ref={inputRef}
              type="file"
              accept="image/*"
              onChange={(e) => {
                if (
                  e.target &&
                  e.target.files &&
                  e.target.files[0] &&
                  e.target.files[0]
                ) {
                  const newImage = e.target.files[0];
                  setImageFile(newImage);
                }
                if (inputRef.current) {
                  inputRef.current.value = '';
                  setIsOpen(false);
                }
              }}
            />
            {image ? (
              <ButtonLarge
                outlined={true}
                inverted={true}
                title="Remove"
                backgroundColor="oxfordBlue"
                onClick={(e) => {
                  setIfLoading(true);
                  deleteImageHandler(e);
                  setIsOpen(false);
                }}
                loading={isLoading}
                disabled={isLoading}
              />
            ) : (
              ''
            )}
            <ButtonLarge
              outlined={true}
              inverted={true}
              title="Close"
              backgroundColor="oxfordBlue"
              onClick={() => {
                setIsOpen(false);
              }}
            />
          </ButtonBlockColumn>
        </Modal>
      )}
      {imageFile && (
        <Cropper
          imageFile={imageFile}
          onImageCompletion={uploadImageHandler}
          previousImages={[]}
        />
      )}
    </>
  );
};

export default PilotWelcome;
